// import FloatingLabel from "react-bootstrap/FloatingLabel";
import React, { useRef, useEffect, useContext, useState } from 'react';
import { useParams } from "react-router-dom";
import { useAuth } from "../../../../hooks/auth";
import { Button, Modal, Row, Col } from "react-bootstrap";
import TextArea from "../../../../components/TextArea";
import { Form } from "@unform/web";
import * as Yup from 'yup';
import { SubmitHandler, FormHandles } from "@unform/core";
import { ToastContext } from "../../../../contexts/toast/toastContext";
import { getSingleErrorMessage } from "../../../../helpers/getSingleErrorMessage";
import api from '../../../../services/api';
import getValidationErrors from '../../../../helpers/getValidateErrors';
import { IListTipologias, IPropostaVersaoAtual } from '../../../../interfaces/proposta.interface';
import { ITermo } from '../../../../interfaces/termo.interface';

interface Props {
  onHideModal: () => void;
  botaoSalvarTermo: boolean;
  onEdit:boolean;
  additional?: IPropostaVersaoAtual; 
  dados:IListTipologias;
  idVersao:number;
  listaDeTermos?: ITermo[];
}

const ModalEditarTermo: React.FC<Props> = ({ onHideModal, botaoSalvarTermo, onEdit, additional, dados, idVersao, listaDeTermos}) => {
  //Ref
  const formRef = useRef<FormHandles>(null);
  
  //Parâmetros
  const { pId }: any = useParams();
  const { fabricante } = useAuth();
  const [termo, setTermo] = useState<ITermo[]>([...(listaDeTermos || [])]);
  const [termoSelecionadoId, setTermoSelecionadoId] = useState<number | null>(null);

  
  //Context
  const toastContext = useContext(ToastContext);

  // Effects
useEffect(() => {
  if(additional?.termo !== null){
    setTermo([    
    {
      termoId: 0,
      nome:"Termo da versão",
      texto:additional?.termo ? String(additional?.termo) : "",
      padrao:false,
      fabricanteId:0,
    },
    ...(listaDeTermos || []),
  ]);

  setTermoSelecionadoId(0);
  }

}, [listaDeTermos]);

  useEffect(() => {
      if(additional?.termo == null){
        formRef.current?.setFieldValue('textoTermo', dados.termo ?  String(dados.termo) : "");   
      }else{
        formRef.current?.setFieldValue('textoTermo', additional?.termo ?  String(additional?.termo) : "");       
      }    
  }, []);

  //Handles
  const handleSubmitEditarTermo: SubmitHandler = async (value) => {
    try {
        formRef.current?.setErrors({});

        const message = "Esse campo não pode ficar vazio.";
        const schema = Yup.object().shape({
          textoTermo: Yup.string().required(message),
        });
        await schema.validate(value, { abortEarly: false });

        //Passou pela validação
        const dadosTermos = {
          propostaId: pId,
          IdPropostaVersao: additional?.id,
          textoTermo: value.textoTermo,
        };

        await api.post("/Propostas/IncluirTermo", dadosTermos);
        toastContext.notification("Termo atualizado.", "success");
        formRef.current?.reset();
        onHideModal();

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        formRef.current?.setErrors(getValidationErrors(err));
      } else {
        const message = getSingleErrorMessage(err);
        if (message) {
          toastContext.notification(message, "error");
        } else {
          toastContext.notification(
            "Ocorreu um erro ao realizar essa operação.",
            "error"
          );
        }
      }
    }
};

const handleChange = (item: ITermo) => {
  setTermoSelecionadoId(item.termoId);
  formRef.current?.setFieldValue('textoTermo', item.texto);
};

  return (
    <>
      {/* Modal Termo de Uso*/}
        <Modal.Header closeButton>
          <Modal.Title>{fabricante ? "Editar Termo de Uso | Garantia" : "Termo de Uso | Garantia"} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-1">
          <div className='card-body'>
            <Row>
            {fabricante ? 
              <Col md={3}>
                <label className="form-label">Lista dos termos de Uso</label>
                <div style={{ maxHeight: "255px", overflowY: "auto" }}>
                  {termo.map((item) => (
                    <div key={item.termoId} className="form-check my-2">
                      <input 
                        type="radio"
                        className="form-check-input"
                        name="termo"
                        id={`termo-${item.termoId}`}
                        value={item.termoId}
                        checked={termoSelecionadoId === item.termoId}
                        onChange={() => handleChange(item)}                        
                        disabled={!botaoSalvarTermo || !additional?.ativo}
                      />
                      <label className="form-check-label" htmlFor={`termo-${item.termoId}`}>
                        {item.nome}
                      </label>
                    </div>
                  ))}
                </div>
              </Col>
            : <></>}

              <Col md={fabricante ? 9 : 12}>
              <Form
                  ref={formRef} 
                  onSubmit={handleSubmitEditarTermo}
                >
                <div >
                  <TextArea 
                    name="textoTermo"
                    label="Descritivo" 
                    placeholder="Digite um texto..."
                    className='form-control'
                    maxLength={8000}
                     disabled={!botaoSalvarTermo || !additional?.ativo}
                  />
                </div>  
                </Form>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="text-center">           
                {fabricante  &&
                    <Button 
                      variant="primary" 
                      className="mt-5"  
                      onClick={() => formRef.current?.submitForm()}
                      disabled={!botaoSalvarTermo || !additional?.ativo}
                    >
                      <i className="fa fa-save mr-2"></i>
                      Salvar
                    </Button>
                }
              </Col>
            </Row>
          </div>
        </Modal.Body>
     
    </>
  );
};

export default ModalEditarTermo;
